<template>
  <div class="relative mt-4 lg:mt-18">
    <NuxtLink
      :to="
        blog?.slug
          ? localePath(
              `/blog/${blog?.categories[0]?.slug || 'all'}/${blog.slug}`,
            )
          : undefined
      "
      :aria-label="blog.currentTranslation?.title"
    >
      <div :class="['featured-blog__image relative', !image?.file?.url && '']">
        <UiLazyImg
          :cover="true"
          :alt="image?.alt || blog.currentTranslation?.title || $t('image')"
          :src="image?.file?.url || recoverPasswordImage"
        />
      </div>
    </NuxtLink>
    <div
      class="absolute bottom-6 left-6 flex w-[90%] flex-col gap-4 sm:bottom-18 sm:left-18 sm:w-[80%] lg:w-[586px]"
    >
      <div class="ui-text-m font-normal text-white">{{ publishedAt }}</div>
      <div class="flex flex-col gap-2.5">
        <span class="ui-h3 text-white">
          <NuxtLink
            :to="
              blog?.slug
                ? localePath(
                    `/blog/${blog?.categories[0]?.slug || 'all'}/${blog.slug}`,
                  )
                : undefined
            "
          >
            {{ blog.currentTranslation?.title }}
          </NuxtLink>
        </span>
      </div>
      <PagesBlogTag
        v-if="blog.categories?.[0]?.currentTranslation?.title"
        :tag="blog.categories?.[0]?.currentTranslation?.title"
        :color="'#FFF'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { format } from "date-fns";
import { Blog } from "ecom-types";
import recoverPasswordImage from "~/assets/images/recoverPassworImage.jpg";

const props = defineProps<{
  blog: Blog;
}>();

const localePath = useLocalePath();
const generalStore = useGeneralStore();

const publishedAt = computed(() => {
  return props.blog?.published_at
    ? format(new Date(props.blog.published_at), generalStore.getSystemDateFormat)
    : "";
});

const image = computed(() => {
  return props.blog?.medias?.find((el) => el.position === "list") || null;
});
</script>

<style>
.featured-blog__image {
  @apply aspect-h-[460] aspect-w-[358] block object-cover lg:aspect-h-[640] lg:aspect-w-[1296];
}
</style>
